export default (state, param) => {
  state.list.detail = param
}



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/mutations/setContactFormSort.js